import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import SelectListAnswer from '@/components/shared/answer-types/select-list/select-list.vue';
import NumberAnswer from '@/components/shared/answer-types/number/number.vue';
import {
    MAX_MEMBERSHIP_PRICE,
    MIN_MEMBERSHIP_PRICE,
    MEMBERSHIP_PRICE_PRECISION,
    DEFAULTS
} from '../../constants/club-registration-constants.js';

export default {
    name: 'MembershipTypesSection',

    components: {
        'text-answer': TextAnswer,
        'select-list-answer': SelectListAnswer,
        'number-answer': NumberAnswer
    },

    props: {
        assignedMembershipTypes: {
            type: Array,
            required: true
        },
        availableMembershipTypes: {
            type: Array,
            required: true
        },
        selectedMembershipTypeId: {
            type: [Number, String],
            default: null
        },
        selectedMembershipTypePrice: {
            type: Number,
            default: null
        },
        newMembershipTypeName: {
            type: String,
            default: ''
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        selectedMembershipTypeValid: {
            type: Boolean,
            default: true
        },
        selectedMembershipTypeErrors: {
            type: Array,
            default: () => []
        },
        membershipTypePriceValid: {
            type: Boolean,
            default: true
        },
        membershipTypePriceErrors: {
            type: Array,
            default: () => []
        },
        newMembershipTypeNameValid: {
            type: Boolean,
            default: true
        },
        newMembershipTypeNameErrors: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            defaults: DEFAULTS,
            maxPrice: MAX_MEMBERSHIP_PRICE,
            minPrice: MIN_MEMBERSHIP_PRICE,
            pricePrecision: MEMBERSHIP_PRICE_PRECISION
        };
    },

    computed: {
        localAssignedMembershipTypes: {
            get() { return this.assignedMembershipTypes; },
            set(value) { this.$emit('update:assignedMembershipTypes', value); }
        },
        localSelectedMembershipTypeId: {
            get() { return this.selectedMembershipTypeId; },
            set(value) { this.$emit('update:selectedMembershipTypeId', value); }
        },
        localSelectedMembershipTypePrice: {
            get() { return this.selectedMembershipTypePrice; },
            set(value) { this.$emit('update:selectedMembershipTypePrice', value); }
        },
        localNewMembershipTypeName: {
            get() { return this.newMembershipTypeName; },
            set(value) { this.$emit('update:newMembershipTypeName', value); }
        },
        membershipTypeOptions() {
            const assignedIds = this.localAssignedMembershipTypes.map(t => t.clubMembershipTypeId);
            return this.availableMembershipTypes
                .filter(t => !assignedIds.includes(t.value))
                .map(t => ({ label: t.label, value: t.value }));
        }
    },

    methods: {
        assignMembershipType() {
            this.$emit('assign-membership-type');
        },

        removeMembershipType(index) {
            this.$emit('remove-membership-type', index);
        },

        addNewMembershipType() {
            this.$emit('add-new-membership-type');
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/register-club/sections/membership-types-section/membership-types-section.js